import React, { useEffect, useRef, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { FormikButton, FormikGrid, FormikTextField } from '@sierralabs/react-material-ui-formik';
import { useCreateGroup } from '@sierralabs/user-ui';
export const CreateGroupDialog = props => {
    const { open, parent, onCancel, onCreated } = props;
    const onCreatedRef = useRef(onCreated);
    const formikRef = useRef(null);
    const [error, setError] = useState();
    const { createdGroup, isCreating, error: createError, createGroup } = useCreateGroup();
    // clear state
    useEffect(() => {
        !open && setError(undefined);
    }, [open]);
    useEffect(() => {
        var _a;
        (_a = formikRef.current) === null || _a === void 0 ? void 0 : _a.setSubmitting(isCreating);
    }, [isCreating]);
    useEffect(() => {
        var _a;
        if (createdGroup) {
            (_a = onCreatedRef.current) === null || _a === void 0 ? void 0 : _a.call(onCreatedRef, createdGroup);
        }
    }, [createdGroup]);
    useEffect(() => {
        setError(createError);
    }, [createError]);
    return (React.createElement(Dialog, { fullWidth: true, maxWidth: 'xs', open: open, onClose: onCancel },
        React.createElement(Formik, { innerRef: formikRef, initialValues: { name: '', description: '' }, validationSchema: Yup.object({
                name: Yup.string().required('Required'),
                description: Yup.string().optional()
            }), onSubmit: (group) => {
                const dto = Object.assign({}, group);
                if (parent) {
                    dto.parentId = parent.id;
                }
                createGroup(dto);
            } },
            React.createElement(Form, { autoComplete: 'off' },
                React.createElement(DialogTitle, null, "Create Group"),
                React.createElement(DialogContent, null,
                    parent && (React.createElement(DialogContentText, null,
                        "Creating group under ",
                        React.createElement("strong", null, parent.path),
                        ".")),
                    React.createElement(FormikGrid, null,
                        React.createElement(FormikTextField, { autoFocus: true, type: 'text', name: 'name', label: 'Group Name' }),
                        React.createElement(FormikTextField, { type: 'text', name: 'description', label: 'Group Description' })),
                    error && React.createElement(Alert, { severity: 'error' }, error.message)),
                React.createElement(DialogActions, null,
                    React.createElement(Button, { onClick: onCancel }, "Cancel"),
                    React.createElement(FormikButton, null, "Create"))))));
};
export default CreateGroupDialog;
//# sourceMappingURL=CreateGroupDialog.js.map